import React, { Component } from 'react';
import {Form } from 'react-bootstrap';
import graph_plot_data from './ChartData';
import {AreaChart, XAxis, YAxis, CartesianGrid, Label, Area, ResponsiveContainer, ReferenceLine} from 'recharts'


var prob_stats = {'-10': 0.6100034117558796,
    '-15': 0.2477775631923528,
    '-20': 0.12950200952930033,
    '-25': 0.07797681268418649,
    '-30': 0.0514123328819956,
    '-35': 0.03610800126207091,
    '-40': 0.02656689564358665,
    '-5': 2.681789180014558,
    '0': 193.7278396311447,
    '5': 995.4673445252998}

class GDPChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: -10,
            // line_data: [ {
            //     x: this.state.value, y: 1,
            //     x: this.state.value, y: 0,
            // } ]
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    render() {
        return <div>
            <ResponsiveContainer width="90%" height={350}>
            <AreaChart data={graph_plot_data}
                       margin={{ top: 20, right: 0, left: 0, bottom: 0 }}>
                <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#A9A9A9" stopOpacity={0.8}/>
                        <stop offset="95%" stopColor="#A9A9A9" stopOpacity={0}/>
                    </linearGradient>
                </defs>
                <XAxis dataKey="x" type='number'/>
                <YAxis type='number'/>
                <CartesianGrid strokeDasharray="3" />
                <ReferenceLine x={(this.state.value - 0.6034749034749037) / 0.9646200050862953} stroke="black" strokeDasharray="3 3"
                               label={<Label value={((this.state.value - 0.6034749034749037) / 0.9646200050862953).toFixed(1) + ' s.d.'}   position="top"/>}>
                </ReferenceLine>
                {/*<Tooltip />*/}
                <Area type="monotone" dataKey="y" stroke="#505050" fillOpacity={1} fill="url(#colorUv)" />
            </AreaChart>
            </ResponsiveContainer>
            <Form className="text-center">
                <Form.Group controlId="formBasicRange">
                    <Form.Control type="range" variant='dark'  min="-25" max="5" step="5" value={this.state.value} onChange={this.handleChange} />
                    <div>{this.state.value}%</div>
                    <div>
                        <b>Quarterly growth rate</b>
                    </div>
                    <div>
                        {prob_stats[this.state.value.toString()].toFixed(1)} years or {(4 * prob_stats[this.state.value.toString()]).toFixed(1)} quarters
                    </div>
                    <div><b>Number of years or quarters in the next 1,000 years selected growth rate (or lower) is predicted to happen, based on our most common models</b></div>
                </Form.Group>
            </Form>
            </div>
    }
}
export default GDPChart;
